// Rendered once per FC from AndonBoard (and WorkstationSelector for EventExplorer).
// Fetches that FC's workstations and reports them via onLoaded. Can't call
// useGetWorkstationsForFcIdQuery in a loop from the parent (rules of hooks), so
// this component does it instead. Renders nothing.
import { useEffect } from "react";

import { useGetWorkstationsForFcIdQuery } from "~/redux/warehouse/workstation.hooks";
import { WorkstationSummaryDto } from "~/types/api";

export type FcWorkstationFetcherProps = {
  fulfillmentCenterId: string;
  onLoaded: (
    fulfillmentCenterId: string,
    workstations: WorkstationSummaryDto[] | undefined
  ) => void;
};

export function FcWorkstationFetcher({
  fulfillmentCenterId,
  onLoaded
}: FcWorkstationFetcherProps) {
  const { data, isSuccess } = useGetWorkstationsForFcIdQuery({
    fulfillmentCenterId
  });

  useEffect(() => {
    if (isSuccess) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
      onLoaded(fulfillmentCenterId, data ?? []);
    }
  }, [fulfillmentCenterId, data, isSuccess, onLoaded]);

  return null;
}

export default FcWorkstationFetcher;
